import React from "react";
import styled from "styled-components";
import InbioOWIContentImg from "./InbioOWIContentImg";
import MLGreyscaleIcon from "styles/images/ml-grey.svg";

export default function InbioRewardsLinksAndOWIContent({ 
  rewardsLinksAndOWIContent, 
  getIpAndPublishToSns
}) {
  const InbioRewardsLinksAndOWIContainer = styled("div")`
    display: flex;
    flex-direction: row;
    margin-top: 24px;
    width: 100%;
  `;

  const InbioRewardsLinksAndOWIDesktopContainer = styled("div")`
    display: none;
    @media only screen and (min-width: 572px) {
      display: flex;
      width: 100%;
    }
  `;

  const InbioRewardsLinksAndOWIMobileContainer = styled("div")`
    display: flex;
    width: 100%;
    @media only screen and (min-width: 572px) {
      display: none;
    }
  `;

  const InbioRewardsLinksAndOWIContainerColumn = styled("div")`
    width: 33%;

    @media only screen and (max-width: 572px) {
      width: 50%;
    }
  `;

  const InbioRewardsLinksAndOWIContentContainer = styled("div")`
    cursor: pointer;
    margin-bottom: 1rem;
    position: relative;
  `;

  const UnavailableInbioRewardsLinksAndOWIContent = styled("div")`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(240, 244, 248, 1);
    width: 100%;
    aspect-ratio: 1;
    flex-direction: column;
  `;

  function getInbioRewardsLinksAndOWIContent() {
    let firstColumnContents = [];
    let secondColumnContents = [];
    let thirdColumnContents = [];
    let firstMobileColumnContents = [];
    let secondMobileColumnContents = [];

    rewardsLinksAndOWIContent.forEach((c, idx) => {
      if (idx % 3 === 0) {
        firstColumnContents.push(c);
      } else if (idx % 3 === 1) {
        secondColumnContents.push(c);
      } else {
        thirdColumnContents.push(c);
      }

      if (idx % 2 === 0) {
        firstMobileColumnContents.push(c);
      } else {
        secondMobileColumnContents.push(c);
      }
    });

    return (
      <InbioRewardsLinksAndOWIContainer>
        <InbioRewardsLinksAndOWIDesktopContainer>
          <InbioRewardsLinksAndOWIContainerColumn
            style={{ marginRight: "1rem" }}
          >
            {getInbioRewardsLinksAndOWIColumnContents(firstColumnContents)}
          </InbioRewardsLinksAndOWIContainerColumn>
          <InbioRewardsLinksAndOWIContainerColumn
            style={{ marginRight: "1rem" }}
          >
            {getInbioRewardsLinksAndOWIColumnContents(secondColumnContents)}
          </InbioRewardsLinksAndOWIContainerColumn>
          <InbioRewardsLinksAndOWIContainerColumn>
            {getInbioRewardsLinksAndOWIColumnContents(thirdColumnContents)}
          </InbioRewardsLinksAndOWIContainerColumn>
        </InbioRewardsLinksAndOWIDesktopContainer>
        <InbioRewardsLinksAndOWIMobileContainer>
          <InbioRewardsLinksAndOWIContainerColumn
            style={{ marginRight: "1rem" }}
          >
            {getInbioRewardsLinksAndOWIColumnContents(firstMobileColumnContents)}
          </InbioRewardsLinksAndOWIContainerColumn>
          <InbioRewardsLinksAndOWIContainerColumn>
            {getInbioRewardsLinksAndOWIColumnContents(secondMobileColumnContents)}
          </InbioRewardsLinksAndOWIContainerColumn>
        </InbioRewardsLinksAndOWIMobileContainer>
      </InbioRewardsLinksAndOWIContainer>
    );
  }

  function getInbioRewardsLinksAndOWIColumnContents(contentList) {
    let contents = contentList.map((content) => {
      if (content.type === "InbioRewardsLinks") {
        let link = content.description;
        link = new URL(link);
        link.searchParams.set('inbio', content.hash_id);

        return (
          <InbioRewardsLinksAndOWIContentContainer
            key={content.id}
            onClick={() => {
              getIpAndPublishToSns({
                payload: {
                  actor_type: "InbioCustomer",
                  category: "Closet - MagicLink",
                  action: "clicked",
                  label: link,
                  value: content.id,
                  page: window.location.href
                },
                topic: "product_usage_stats",
              });
              window.open(link, "_blank")
            }}
          >
          {content.image_thumb ? (
              <img
                src={content.image_thumb}
                style={{ objectFit: "contain", width: "100%" }}
              />
            ) : (
              <UnavailableInbioRewardsLinksAndOWIContent>
                <img src={MLGreyscaleIcon}/>
                <span
                  style={{fontSize: "10px", color: "grey"}}
                >
                  Image Unavailable
                </span>
              </UnavailableInbioRewardsLinksAndOWIContent>
            )}
          </InbioRewardsLinksAndOWIContentContainer>
        );
      } else if (content.type === "InbioMedia") {
        return (
          <InbioRewardsLinksAndOWIContentContainer
            key={content.id}
            onClick={() => {
              getIpAndPublishToSns({
                payload: {
                  actor_type: "InbioCustomer",
                  category: "Closet - OWI",
                  action: "clicked",
                  label: content.obsessed_shortened_url,
                  value: content.id,
                  page: window.location.href
                },
                topic: "product_usage_stats",
              });
              window.open(`${content.obsessed_shortened_url}`, "_blank")}
            }
          >
            <InbioOWIContentImg
              content={content}
            />
          </InbioRewardsLinksAndOWIContentContainer>
        );
      } else {
        return null;
      }
    });

    return contents;
  }

  return rewardsLinksAndOWIContent.length > 0 && getInbioRewardsLinksAndOWIContent();
}
